import React from 'react'
import { HTMLAttributes, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import moment from 'moment'

// evertel
import { Button } from '../Button'
import { Icon } from '../Icon'
import { APIDataMedia } from '@evertel/types'
import { Row, Col } from '../../layout'
import { Text } from '../Text'
import { formatBytes, getMediaType } from '@evertel/utils'
import { useService } from '@evertel/di'
import { UserController } from '@evertel/blue-user'
import { ProfilePic } from '@evertel/web/user'

interface PhotoGalleryActionBarProps extends HTMLAttributes<HTMLDivElement> {
    media: APIDataMedia
    userController: UserController
    onZoomIn: () => void
    onZoomOut: () => void
    onReset: () => void
    onDownload: () => void
}

const PhotoGalleryActionBar: React.FC<PhotoGalleryActionBarProps> = observer(({
    media,
    userController,
    onZoomIn,
    onZoomOut,
    onReset,
    onDownload,
    ...otherProps
}) => {

    const user = userController?.user

    return (
        <Row className="w-100" {...otherProps}>
            {user && (
                <Row valign="center" className="me-3">
                    <ProfilePic
                        className="me-2"
                        userId={user?.id}
                        width={30}
                        height={30}
                    />
                    <Text color="white">{userController.fullName}</Text>
                </Row>
            )}
            <Col>
                <Text
                    color="white"
                    bold>
                    {media?.fileName}
                </Text>
                <Text
                    color="muted"
                    size="small">
                    {formatBytes(media?.contentLength, 1)}
                    <Text className="mx-2">|</Text>
                    {moment(media?.updatedDate).format('ll')}
                </Text>
            </Col>
            <Col align="end">
                <Row className="flex-wrap">
                    <Button
                        id="photo-gallery-action-bar-zoom-in"
                        color="muted"
                        title="Zoom in"
                        aria-label="Zoom in"
                        className="me-2"
                        ghost
                        onClick={onZoomIn}>
                        <Icon
                            name="magnifying-glass-plus"
                            size={20}
                        />
                    </Button>
                    <Button
                        id="photo-gallery-action-bar-zoom-out"
                        color="muted"
                        title="Zoom out"
                        aria-label="Zoom out"
                        className="me-2"
                        ghost
                        onClick={onZoomOut}>
                        <Icon
                            name="magnifying-glass-minus"
                            size={20}
                        />
                    </Button>
                    <Button
                        id="photo-gallery-action-bar-fit-to-screen"
                        color="muted"
                        title="Fit to screen"
                        aria-label="Fit to screen"
                        className="me-2"
                        ghost
                        onClick={onReset}>
                        <Icon
                            name="arrows-to-circle"
                            size={20}
                        />
                    </Button>
                    <Button
                        id="photo-gallery-action-bar-download"
                        color="muted"
                        title="Download"
                        aria-label="Download"
                        className="me-2"
                        ghost
                        onClick={onDownload}>
                        <Icon
                            name="cloud-arrow-down"
                            size={20}
                        />
                    </Button>
                </Row>
            </Col>
        </Row>
    )
})

export { PhotoGalleryActionBar }
